module.exports = __webpack_public_path__ + "img/knight3_feature_02.bc34a000.jpg";